import React from "react";
import { Icon } from "@material-ui/core";
import OrderButtons from "../../OrderButtons";
import { Order, OrderValue } from "../../../../../globalTypes";
import { StyledDivTh, TableSortContainer, ThWrapper } from "./styles";
import { IMappedHeadColumns } from "./utils";

interface Props extends Omit<IMappedHeadColumns, "isHidden"> {
  onOrder: (columnKey: string, order: OrderValue) => void;
  order: Order;
}

export const TableDataColumn = ({
  columnKey,
  textAlign,
  displayText,
  columnLabel,
  displayIcon,
  icon,
  orderKey,
  onOrder,
  order,
}: Props) => (
  <StyledDivTh
    data-cy="column-header"
    key={columnKey}
    text-align="center"
    className="tableCol"
  >
    <ThWrapper textAlign={textAlign}>
      {displayText && <span>{columnLabel}</span>}
      {displayIcon && <Icon>{icon}</Icon>}
      <TableSortContainer>
        <OrderButtons
          onOrder={onOrder}
          columnKey={orderKey}
          orderItem={order[orderKey]}
        />
      </TableSortContainer>
    </ThWrapper>
  </StyledDivTh>
);
